export default "__VITE_ASSET__CPOsOX____"